export default __webpack_public_path__ + "static/media/banh-cuon.061fac51.jpg";